export const environment = {
  production: false,
  url: 'https://dev.api.lingon.io',
  logLocalDBActions: false,
  whiteList: true,
  googleAnalytics: 'G-Y7YHKHEPD6',
  frontUrl: 'https://dev.app.lingon.io',
};
